import _ from 'lodash'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { FeatureName, FeatureValues } from './types'
import { FeatureAvailability } from './featuresSchema'

export type State = {
  values: {
    statsig: FeatureValues
    userSettings: FeatureValues
    devForcedFeatures: FeatureValues
  }
  availabilities: Record<FeatureName, FeatureAvailability> | null
  areValuesReady: boolean
  isStatsigApiReady: boolean
  didStatsigInitFail: boolean
}

export type FeatureValueSet = keyof State['values']

const initialState: State = {
  values: {
    statsig: {},
    userSettings: {},
    devForcedFeatures: {}
  },
  availabilities: null,
  areValuesReady: false,
  isStatsigApiReady: false,
  didStatsigInitFail: false
}

const slice = createSlice({
  name: 'features',
  initialState,
  reducers: {
    markStatsigAsReady: (state, action: PayloadAction<{ didStatsigInitFail: boolean }>) => {
      // areValuesReady is persisted along with the values, isStatsigApiReady is not
      state.areValuesReady = true
      state.isStatsigApiReady = true
      state.didStatsigInitFail = action.payload.didStatsigInitFail
    },
    setFeatureValues: (
      state,
      action: PayloadAction<{ set: FeatureValueSet; values: FeatureValues }>
    ) => {
      const { set, values } = action.payload

      state.values[set] = _.omitBy(values, _.isUndefined)
    },
    setAvailabilities: (
      state,
      action: PayloadAction<Record<FeatureName, FeatureAvailability> | null>
    ) => {
      state.availabilities = action.payload
    }
  }
})

export const reducer = slice.reducer
export const actions = slice.actions
